import React, { useState, useEffect } from 'react';

export default function Login() {
     const [email, setEmail] = useState('');
     const [code, setCode] = useState('');
     const [step, setStep] = useState(1); // 1 = email, 2 = code
     const [message, setMessage] = useState('');
     const [cooldown, setCooldown] = useState(0);
     const [isLoading, setIsLoading] = useState(false);

     // Cooldown countdown
     useEffect(() => {
          if (cooldown <= 0) return;
          const timer = setInterval(() => setCooldown(prev => prev - 1), 1000);
          return () => clearInterval(timer);
     }, [cooldown]);

     // Request one-time code
     const handleRequestCode = async () => {
          if (!email) return;

          setIsLoading(true);
          const res = await fetch('/request-code.php', {
               method: 'POST',
               body: new URLSearchParams({ email }),
          });

          const data = await res.json();
          setIsLoading(false);

          if (res.ok) {
               setMessage('A login code has been sent to your email.');
               setCooldown(60); // cooldown in seconds
               setStep(2);
          } else {
               setMessage(data.error || 'Something went wrong');
          }
     };

     // Submit code for login
     const handleVerifyCode = async () => {
          if (!email || !code) return;

          setIsLoading(true);
          const res = await fetch('/verify-code.php', {
               method: 'POST',
               body: new URLSearchParams({ email, code }),
               credentials: 'include' // important to send cookie
          });

          const data = await res.json();
          setIsLoading(false);

          if (res.ok) {
               localStorage.setItem('access_token', data.access_token);
               setMessage('Login successful!');
               // Redirect or update app state here
          } else {
               setMessage(data.error || 'Login failed.');
          }
     };

     return (
          <div className="login-page form-floating mb-3 mt-3">
               <h2>Login</h2>

               {step === 1 && (
                    <>
                         <input
                              className = 'form-control'
                              type="email"
                              placeholder="Enter your email"
                              value={email}
                              disabled={cooldown > 0}
                              onChange={e => setEmail(e.target.value)}
                              style={{ width: '100%', marginBottom: 10 }}
                         />
                         <button onClick={handleRequestCode} disabled={cooldown > 0 || isLoading} className='btn btn-outline-secondary'>
                              {cooldown > 0 ? `Wait ${cooldown}s` : 'Send Login Code'}
                         </button>
                    </>
               )}

               {step === 2 && (
                    <>
                         <input
                              type="text"
                              placeholder="Enter the code"
                              value={code}
                              onChange={e => setCode(e.target.value)}
                              style={{ width: '100%', marginBottom: 10, marginTop: 20 }}
                         />
                         <button onClick={handleVerifyCode} disabled={isLoading}>
                              Verify and Log In
                         </button>
                         <div style={{ marginTop: 10 }}>
                              <button onClick={handleRequestCode} disabled={cooldown > 0}>
                                   {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend Code'}
                              </button>
                         </div>
                    </>
               )}

               {message && <p style={{ marginTop: 20 }}>{message}</p>}
          </div>
     );
}
